"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration_1 = require("../../configuration");
/**
 * #config CytobandAdapter
 */
function x() { } // eslint-disable-line @typescript-eslint/no-unused-vars
const configSchema = (0, configuration_1.ConfigurationSchema)('CytobandAdapter', {
    /**
     * #slot
     */
    cytobandLocation: {
        type: 'fileLocation',
        defaultValue: { uri: '/path/to/cytoband.txt.gz' },
    },
}, { explicitlyTyped: true });
exports.default = configSchema;
